import { render, staticRenderFns } from "./EventPositionPrizeMoney.vue?vue&type=template&id=1def5a65"
import script from "./EventPositionPrizeMoney.vue?vue&type=script&lang=js"
export * from "./EventPositionPrizeMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports